function format_perc_100base(value) {
    return Number(value).toFixed(0) + "%" 
}

export default format_perc_100base;
